import {
	stringifyPersonalizationAttributes,
	type StringifiedPersonalizationAttribute,
} from '@confluence/legacy-schema-bridge/entry-points/stringifyPersonalizationAttributes.ts';

import type { ExcludeNewConfluenceActiveUserQueryVariables } from './__types__/ExcludeNewConfluenceActiveUserQuery.ts';
import { useSiteUserTraits, type UseSiteUserTraitsOptions } from './useSiteUserTraits.ts';

export type UseExperimentalSiteUserPersonalizationParams = {
	variables: ExcludeNewConfluenceActiveUserQueryVariables;
	skip?: boolean;
	fetchPolicy?: UseSiteUserTraitsOptions['fetchPolicy'];
};

export type UseExperimentalSiteUserPersonalizationResult = {
	data:
		| {
				experimentalSiteUserPersonalization: {
					attributes: StringifiedPersonalizationAttribute[] | null;
				};
		  }
		| undefined;
	loading: boolean;
	error: Error | undefined;
};

export const useExperimentalSiteUserPersonalization = ({
	skip,
	fetchPolicy,
}: UseExperimentalSiteUserPersonalizationParams): UseExperimentalSiteUserPersonalizationResult => {
	const traitsResult = useSiteUserTraits({
		skip,
		fetchPolicy,
	});

	const adaptedData =
		traitsResult.data !== null
			? {
					experimentalSiteUserPersonalization: {
						attributes: stringifyPersonalizationAttributes(traitsResult.data.attributes),
					},
				}
			: undefined;

	return {
		data: adaptedData,
		loading: traitsResult.loading,
		error: traitsResult.error ?? undefined,
	};
};
